import { GOOGLE_PAY_ORIGIN, PAYMENT_SCRIPT_TIMEOUT_MS } from '../../common/constants/paymentInit';
import { loadScript } from '../../utils/paymentScripts';

const PAY_JS_SRC = `${GOOGLE_PAY_ORIGIN}/gp/p/js/pay.js`;
let readyClient: { client: any; ready: boolean } | null = null;

export const BASE_CARD_PAYMENT_METHOD = {
  type: 'CARD',
  parameters: {
    allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
    allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'],
  },
};

export function loadGooglePayScript(): Promise<void> {
  if ((globalThis as any).google?.payments?.api) return Promise.resolve();

  return loadScript(PAY_JS_SRC, PAYMENT_SCRIPT_TIMEOUT_MS);
}

export async function getGooglePayClient(environment: string): Promise<{ client: any; ready: boolean }> {
  if (readyClient) return readyClient;

  await loadGooglePayScript();

  const client = new (globalThis as any).google.payments.api.PaymentsClient({
    environment,
  });
  const readiness = await client.isReadyToPay({
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [BASE_CARD_PAYMENT_METHOD],
  });

  readyClient = { client, ready: !!readiness?.result };

  return readyClient;
}
